import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledLastMinute = styled.div`
  width: 100%;
  margin-bottom: ${rem('10px')};
  background-color: ${props => props.theme.colors.primary};
  padding: ${rem('2px')} 0;
  min-height: ${rem('53px')};
  position: relative;
  border-top: ${rem('5px')} ${props => props.theme.colors.dark} solid;

  ${mediaqueries.greaterThan('desktop')`
      border-top: none;
    `}

  .list {
    padding: 0;
    margin: 0 auto;
    max-width: 77rem;
    list-style: disc;
  }
  .item {
    padding-left: ${rem('15px')};
    padding-right: ${rem('45px')};
    color: ${props => props.theme.colors.dark};
    margin: ${rem('10px')} 0;
    font-size: ${rem('14px')};
    ${mediaqueries.greaterThan('desktop')`
      padding-left: 0;   
    `}

    &:before {
      content: none;
    }
  }
  .close {
    position: absolute;
    right: ${rem('20px')};
    top: ${rem('10px')};
    z-index: 2;
    width: ${rem('16px')};
    &:hover {
      cursor: pointer;
    }
  }
`;

export { StyledLastMinute };
